var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, isValidElement, } from "react";
import { Button } from "@react-md/button";
import { useMessageQueueActions, useMessageVisibility, } from "./MessageQueueContext";
import { Snackbar } from "./Snackbar";
import { Toast } from "./Toast";
function getId(snackbarId, toastId, actionId) {
    if (actionId) {
        return actionId;
    }
    if (toastId) {
        return "".concat(toastId, "-action");
    }
    return "".concat(snackbarId, "-action");
}
/**
 * Because the toast renderer is a callback function instead of a React
 * component, it's actually required to create a separate component instance so
 * that the context API can be
 *
 * @internal
 */
function SnackbarQueueT(_a, ref) {
    var queue = _a.queue, onActionClick = _a.onActionClick, props = __rest(_a, ["queue", "onActionClick"]);
    var _b = __read(queue, 1), toast = _b[0];
    var visible = useMessageVisibility();
    var _c = useMessageQueueActions(), popMessage = _c.popMessage, hideMessage = _c.hideMessage, startTimer = _c.startTimer;
    var content = null;
    if (toast) {
        var snackbarId = props.id;
        var toastId = toast.id;
        var _messageId = toast.messageId, _messagePriority = toast.messagePriority, _d = toast.disableAutohide, disableAutohide = _d === void 0 ? false : _d, _e = toast.disableActionHide, disableActionHide_1 = _e === void 0 ? false : _e, providedAction = toast.action, toastProps = __rest(toast, ["messageId", "messagePriority", "disableAutohide", "disableActionHide", "action"]);
        var action = null;
        if (providedAction) {
            var actionProps_1 = providedAction;
            var onClick = function (event) {
                if (onActionClick) {
                    onActionClick(toast, event);
                }
                if (actionProps_1.onClick) {
                    actionProps_1.onClick(event);
                }
                if (!disableActionHide_1) {
                    hideMessage();
                }
            };
            var t = typeof providedAction;
            if (isValidElement(providedAction) || t !== "object") {
                action = (_jsx(Button, __assign({ id: getId(snackbarId, toastId, undefined), onClick: onClick, theme: "secondary" }, { children: providedAction }), void 0));
            }
            else {
                action = (_jsx(Button, __assign({ id: getId(snackbarId, toastId, actionProps_1.id), theme: "secondary" }, actionProps_1, { onClick: onClick }), void 0));
            }
        }
        content = (_jsx(Toast, __assign({}, toastProps, { action: action, visible: visible, onEntered: disableAutohide ? undefined : startTimer, onExited: popMessage }), void 0));
    }
    return (_jsx(Snackbar, __assign({}, props, { ref: ref }, { children: content }), void 0));
}
export var SnackbarQueue = forwardRef(SnackbarQueueT);
//# sourceMappingURL=SnackbarQueue.js.map